import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { Grid } from "@/components/Grid";
import { EnterprisePricingSectionItem } from "./EnterprisePricingSectionItem";
import { IUseCaseHeaderSection } from "./types";

type IProps = IUseCaseHeaderSection & JSX.IntrinsicElements["div"];

export const EnterprisePricingSection: React.FC<IProps> = ({
  title,
  subtitle,
  cards,
}) => {
  const { css } = useFela();
  const { bp, colors } = useTheme();
  return (
    <Grid
      id="EnterprisePricingSection"
      customStyle={{
        flexDirection: "column",
        alignItems: "center",
        color: colors.WHITE,
        [bp.FROM_DESKTOP]: {
          padding: "120px 0",
        },
      }}
      wrapperStyle={{
        backgroundColor: colors.GRADIENT_BLUE_DARK,
      }}
    >
      <Heading
        as="h2"
        customStyle={{
          letterSpacing: "-0.01rem",
          textAlign: "center",
          color: colors.WHITE,
          [bp.FROM_DESKTOP]: {
            fontSize: 48,
            lineHeight: "60px",
          },
        }}
      >
        {title}
      </Heading>
      <p className={css({ textAlign: "center", opacity: 0.7 })}>{subtitle}</p>
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          marginTop: 30,
          [bp.FROM_DESKTOP]: {
            flexDirection: "row",
            justifyContent: "center",
            marginTop: 72,
          },
        })}
      >
        {cards.map(card => (
          <EnterprisePricingSectionItem key={card.id} {...card} />
        ))}
      </div>
    </Grid>
  );
};
